import { call, put, takeLatest, takeLeading } from 'redux-saga/effects';
import { partManagementActions } from '../reducers/part-management';
import partManagementService from '../api/partManagement';

function* partManagementDataRequest({ payload }: any): any {
  const res = yield call(partManagementService.getMachine, payload);
  if (res.status === 'success') {
    // console.log(res);
    yield put(partManagementActions.getPartManagementDataResponse(res?.data));
  } else {
    yield put(partManagementActions.getPartManagementDataFailed(res?.code));
  }
}

function* addPartManagement({ payload }: any): any {
  const res = yield call(partManagementService.addPart, payload);
  if (res.status === 'success') {
    yield put(partManagementActions.addPartResponse(res?.code));
  } else {
    yield put(partManagementActions.addPartFailed(res?.code));
  }
}

function* updatePartManagement({ payload }: any): any {
  const res = yield call(partManagementService.updatePart, payload);
  if (res.status === 'success') {
    yield put(partManagementActions.updatePartResponse(res?.code));
  } else {
    yield put(partManagementActions.updatePartFailed(res?.code));
  }
}

function* deletePartManagement({ payload }: any): any {
  const res = yield call(partManagementService.deletePart, payload);
  if (res.status === 'success') {
    yield put(partManagementActions.deletePartResponse(res?.code));
  } else {
    yield put(partManagementActions.deletePartFailed(res?.code));
  }
}

function* bulkUploadData({ payload }: any): any {
  const res = yield call(partManagementService.bulkUpload, payload);
  if (res.status === 'success') {
    yield put(partManagementActions.bulkUploadResponse(res?.code));
  } else {
    yield put(partManagementActions.bulkUploadFailed(res?.code));
  }
}

function* partManagementSaga() {
  yield takeLatest('partManagement/getPartManagementDataRequest', partManagementDataRequest);
  yield takeLeading('partManagement/addPartRequest', addPartManagement);
  yield takeLeading('partManagement/deletePartRequest', deletePartManagement);
  yield takeLeading('partManagement/updatePartRequest', updatePartManagement);
  yield takeLeading('partManagement/bulkUploadRequest', bulkUploadData);
}

export default partManagementSaga;
